import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';

import { CmsEntities } from 'client/data/models/cms';
import { DEFAULT_CONTENT } from 'client/data/cms/content';

import { getFullImageUrl } from 'client/utils/image-helpers';
import { AspectRatioContainer } from 'site-modules/shared/components/aspect-ratio-container/aspect-ratio-container';
import { Link } from 'site-modules/shared/components/link/link';

import './cpo-module.scss';

export function CpoModule({ content = DEFAULT_CONTENT, className = null }) {
  const cards = content.children();
  if (!cards.length) {
    return null;
  }

  const { title } = content;
  const firstCard = cards[0];
  const otherCards = cards.slice(1);
  const lastIndex = otherCards.length - 1;

  return (
    <div className={classnames('cpo-module px-1 py-1_75 rounded-16', className)}>
      <h2 className="heading-3 mb-1_75">{title}</h2>
      <Row>
        <Col xs={12} md={6} className="mb-1_5 mb-md-0">
          <Link to={firstCard.metadata('url').value()} className="d-block text-decoration-none">
            <AspectRatioContainer aspectRatio="89:26" className="mb-0_5">
              <img
                alt=""
                src={getFullImageUrl(firstCard.metadata('image').value())}
                className="w-100 h-100 pos-a center-y rounded"
                loading="lazy"
                decoding="async"
              />
            </AspectRatioContainer>
            <div className="fw-bold small text-uppercase text-blue-30 mb-0_25">
              {firstCard.metadata('promoText').value()}
            </div>
            <div className="fw-bold text-gray-darkest mb-0_5">{firstCard.metadata('title').value()}</div>
            <div
              className="text-gray-darker mb-0_5"
              style={{
                display: '-webkit-box',
                WebkitLineClamp: '3',
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
              }}
            >
              {firstCard.metadata('description').value()}
            </div>
            <div>
              <span className="text-blue-30 text-underline" aria-hidden>
                Read full article
              </span>
              <i className="icon-arrow-right4 size-10 ms-0_25" aria-hidden />
            </div>
          </Link>
        </Col>
        <Col xs={12} md={6} className="d-flex flex-column justify-content-between">
          {otherCards.map((card, index) => (
            <Link
              key={card.metadata('url').value()}
              to={card.metadata('url').value()}
              className={classnames('d-flex text-decoration-none', { 'mb-1': index !== lastIndex })}
            >
              <img
                alt=""
                src={getFullImageUrl(card.metadata('image').value())}
                className="rounded"
                width={'140'}
                height={'115'}
                loading="lazy"
                decoding="async"
              />
              <div className="ms-0_5">
                <div className="fw-bold small text-uppercase text-blue-30 mb-0_25">
                  {card.metadata('promoText').value()}
                </div>
                <div className="fw-medium text-gray-darkest">{card.metadata('title').value()}</div>
              </div>
            </Link>
          ))}
        </Col>
      </Row>
    </div>
  );
}

CpoModule.propTypes = {
  content: CmsEntities.Content,
  className: PropTypes.string,
};
